export enum EstadoConservacao {
  Otimo = 1,
  Bom = 2,
  Regular = 3,
  Ruim = 4,
}

export const opcoesEstadoConservacao: { label: string; value: EstadoConservacao }[] = [
  { label: 'Ótimo', value: EstadoConservacao.Otimo },
  { label: 'Bom', value: EstadoConservacao.Bom },
  { label: 'Regular', value: EstadoConservacao.Regular },
  { label: 'Ruim', value: EstadoConservacao.Ruim },
];

export const opcoesTipoAtributo: { label: string; value: boolean }[] = [
  { label: 'Texto', value: false },
  { label: 'Foto', value: true },
];

/** Foto de um atributo de foto. `arquivo` (já reduzido no aparelho) só existe enquanto a foto está
 * pendente — sobe no próximo Salvar e some quando a tela aplica a vistoria devolvida pela API. */
export interface FotoVistoria {
  chave: string;
  dataCaptura: Date;
  arquivo?: Blob;
}

export interface AtributoPreenchimento {
  id: number;
  nomeModelo: string | null;
  nome: string;
  ehFoto: boolean;
  valor: string;
  fotos: FotoVistoria[];
}

export interface ItemVistoriaPreenchimento {
  id: number;
  nomeModelo: string | null;
  nome: string;
  atributos: AtributoPreenchimento[];
  estadoConservacao: EstadoConservacao | null;
  observacao: string;
}
